import { isNil, isString } from 'lodash-es';
import { ExportVersionFile, ExportFileType } from 'common/types';
import { FileExtToPreviewType } from 'common/constants';
import { getEnv } from './getEnv';

export const getExtFromFileName = (fileName: string) => {
  if (fileName && isString(fileName)) {
    const name = removeQueryParams(fileName);
    const index = name.lastIndexOf('.');
    //获取后缀
    return name.substring(index + 1);
  } else {
    return '';
  }
};

export const mapExtToPreviewType = (ext: string | undefined | null, type: string) => {
  if (!ext) {
    return ExportFileType.Other;
  }
  if (type === 'Animation') {
    return ExportFileType.Animation;
  }

  let extension = FileExtToPreviewType[ext.toLowerCase()];

  if (!extension) {
    extension = ExportFileType.Other;
  }
  return extension;
};
const isTwoDimensionArray = (arr: any) => {
  if (!isNil(arr) && Array.isArray(arr)) {
    return arr.some((items) => Array.isArray(items));
  } else {
    return false;
  }
};
export const mapToPreviewType = (
  file: Pick<ExportVersionFile, 'type' | 'exportFileUrl' | 'fileName' | 'exportFileType'>,
) => {
  let exportUrl = '';
  if (Array.isArray(file.exportFileUrl)) {
    exportUrl = file.exportFileUrl[0];
  } else {
    exportUrl = file.exportFileUrl;
  }
  // 先从exportFileType取类型
  if (file.exportFileType && file.exportFileType.length > 0) {
    return file.exportFileType[0] as ExportFileType;
  }
  // 从文件名获取后缀
  const originFileNameExt = getExtFromFileName(file.fileName);
  const exportExt = getExtFromFileName(exportUrl);

  if (originFileNameExt && originFileNameExt.toLowerCase() === 'ztl') {
    if (exportExt.toLowerCase() === 'jpg') {
      //turntable导出图片一定是jpg
      return ExportFileType.TurnTable;
    } else {
      return ExportFileType.Other;
    }
  } else if (originFileNameExt && originFileNameExt.toLowerCase() === 'naraka_mobile_map') {
    return ExportFileType.LibraryTurntable;
  } else if (originFileNameExt && originFileNameExt.toLowerCase() === 'naraka_mobile_component') {
    return ExportFileType.LibraryTurntable;
  }
  if (isTwoDimensionArray(file.exportFileUrl)) {
    return ExportFileType.TurnTable;
  }
  const ext = getExtFromFileName(exportUrl);
  if (ext) {
    return mapExtToPreviewType(ext, file.type);
  } else {
    return ExportFileType.Other;
  }
};
export const getPreviewTypeAndUrl = (firstFile: ExportVersionFile) => {
  let type = mapToPreviewType(firstFile);

  //兼容质检服务异常情况
  if (type === ExportFileType.TurnTable && !Array.isArray(firstFile.exportFileUrl)) {
    type = ExportFileType.Image;
  }

  const url = getPreviewFileUrl({ type, exportFileUrl: firstFile.exportFileUrl });

  const { fosHost } = getEnv();
  // 如果是fos绝对域名， 换成/proxy-host
  if (url && fosHost) {
    // 如果是一维数组
    if (Array.isArray(url) && url.length > 0 && isString(url[0])) {
      return {
        type,
        url: url.map((item) => item.replace(fosHost, '/proxy-host')),
        fileName: firstFile.fileName,
      };
      //如果是二维数组
    } else if (isTwoDimensionArray(url)) {
      return {
        type,
        url: url.map((item) => item.map((i) => i.replace(fosHost, '/proxy-host'))),
        fileName: firstFile.fileName,
      };
    } else if (typeof url === 'string') {
      return {
        type,
        url: url.replace(fosHost, '/proxy-host'),
        fileName: firstFile.fileName,
      };
    }
  }
  return {
    type,
    url,
    fileName: firstFile.fileName,
  };
};
const removeQueryParams = (url) => {
  return url.split('?')[0];
};
export const getPreviewFileUrl = (params: { type: ExportFileType; exportFileUrl?: string | string[] }) => {
  if (!params.exportFileUrl) {
    return '';
  }

  // if (params.type === ExportFileType.TurntableVideo && Array.isArray(params.exportFileUrl)) {
  //   return params.exportFileUrl;
  // }
  if (
    params.type !== ExportFileType.TurnTable &&
    params.type !== ExportFileType.LibraryTurntable &&
    Array.isArray(params.exportFileUrl)
  ) {
    return params.exportFileUrl[0];
  }

  return params.exportFileUrl;
};
